// @flow

export const HELP_REFERENCE_FIELDS_PAGE = '/docs/reference-fields';
